export class PerformanceRequest {

  public method: string;
  public url: string;
  public urlShort: string;
  public status: number;
  public responseHeaders: any;
  public fileSize: number;
  public startOffset: number;
  public startTime: number;
  public duration: number;
  public timelineChartData: any[];

}
